import { Stack, Typography } from '@mui/material';

import { ResourceMenuActions } from '../../organisms/ResourceMenuActions';
import { ResourceTimelineSeparator } from '../ResourceTimelineSeparator';
import {
  type ResourceTimelineItemProps,
  useResourceTimelineItem,
} from './useResourceTimelineItem';

type Props = ResourceTimelineItemProps;

export function ResourceTimelineItem(props: Props) {
  const hook = useResourceTimelineItem(props);

  return (
    <Stack
      direction="row"
      data-testid={props['data-testid'] ?? 'resource-timeline-item'}
      sx={{
        alignItems: 'stretch',
        width: '100%',
        minHeight: 'auto',
      }}
    >
      <ResourceTimelineSeparator variant={props.color} />

      <Stack
        spacing={0.5}
        sx={{
          flex: 1,
          minWidth: 0,
          pt: hook.hasChildren ? 1.5 : 1,
          pb: 1,
          pl: 1.75,
          justifyContent: hook.hasChildren ? 'flex-start' : 'center',
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: 'flex-start',
            justifyContent: 'space-between',
          }}
        >
          <Stack direction="column" sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body1Emphasis">
              {props.title}
            </Typography>

            {hook.hasSubtitle ? (
              <Typography variant="caption">
                {props.subtitle}
              </Typography>
            ) : null}
          </Stack>

          {props.action ? (
            <Stack sx={{ flexShrink: 0, ml: 1, alignSelf: 'flex-start', mt: -0.5 }}>{props.action}</Stack>
          ) : hook.hasActions ? (
            <Stack sx={{ flexShrink: 0, ml: 1, alignSelf: 'flex-start', mt: -0.5 }}>
              <ResourceMenuActions
                actions={hook.actions}
                tooltip={hook.actionsButtonTooltip}
                ariaLabel={hook.actionsButtonAriaLabel}
              />
            </Stack>
          ) : null}
        </Stack>

        {hook.hasChildren ? (
          typeof props.children === 'string' ? (
            <Typography variant="body2">
              {props.children}
            </Typography>
          ) : (
            props.children
          )
        ) : null}
      </Stack>
    </Stack>
  );
}

export type { Props as ResourceTimelineItemProps };
